interface WildCardProps {
  compact?: boolean;
  className?: string;
  selected?: boolean;
  orderLabel?: number;
  onClick?: () => void;
  testId?: string;
}

export function WildCard({ compact = false, className = '', selected, orderLabel, onClick, testId }: WildCardProps) {
  const Component = onClick ? 'button' : 'div';

  return (
    <Component
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      data-testid={testId}
      data-card-type="wild"
      data-selected={selected ? 'true' : 'false'}
      data-order={orderLabel ?? undefined}
      aria-pressed={onClick ? Boolean(selected) : undefined}
      className={[
        compact ? 'w-36 h-48 md:w-40 md:h-52 p-4 shrink-0' : 'w-40 h-52 p-4',
        'wild-glow rounded-xl flex flex-col justify-between shadow-xl border border-primary-container relative text-left',
        selected ? 'ring-4 ring-primary selected-glow -translate-y-4 z-10' : 'hover:-translate-y-3 transition-all duration-300',
        className,
      ].join(' ')}
    >
      {orderLabel !== undefined ? (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary text-on-primary text-xs font-black w-7 h-7 rounded-full flex items-center justify-center shadow-lg z-10">
          {orderLabel}
        </span>
      ) : (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary-container text-white text-[10px] font-black px-2 py-0.5 rounded-full shadow-sm">
          WILD
        </div>
      )}
      <div className="flex flex-col gap-2 h-full justify-center">
        <span className="text-[10px] font-bold text-primary italic uppercase">Write-In</span>
        <span className="text-white/70 font-card-text text-xs">Tap to select, then submit</span>
      </div>
    </Component>
  );
}
